import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';

import {useFolderByHashid} from 'app/folders/api';
import {CreateFolderModal} from 'app/folders/components/dashboards/CreateFolder';

interface Props {
  folderHashid?: string;
  finalCallback: () => void;
  show: boolean;
}
export function AddFolderToFolder({folderHashid, show, finalCallback}: Props) {
  const {currentData: selectedFolder} = useFolderByHashid(
    folderHashid != null ? folderHashid : skipToken
  );

  return (
    <CreateFolderModal
      show={show}
      onCancel={finalCallback}
      parent={selectedFolder}
      teams={selectedFolder?.teams}
      autoFocus={true}
    />
  );
}
